<template>
  <div class="i-coaching-benefits">
    <div class="heading">
      <div class="title">Why Career Coaching Works</div>
      <div class="subtitle">Get the outcomes that matter most to your career growth</div>
    </div>
    <div class="card">
      <div class="benefits">
        <template
          v-for="benefit in BENEFITS"
          :key="benefit.icon"
        >
          <div class="benefit">
            <img :src="benefit.icon" />
            <div class="text">
              <div class="main">{{ benefit.title }}</div>
              <div class="description">{{ benefit.text }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// ASSETS
import iconCareer from "@/assets/icons/icon-welcome-career.svg"
import iconLinkedIn from "@/assets/icons/icon-welcome-linkedin.svg"
import iconInterview from "@/assets/icons/icon-welcome-interview.svg"
import iconSalary from "@/assets/icons/icon-welcome-salary.svg"

const BENEFITS = [
  {
    icon: iconCareer,
    title: "Find Your Perfect Role",
    text: "Get clarity on career paths that truly fit you and land more interviews with proven job search tactics"
  },
  {
    icon: iconLinkedIn,
    title: "Become a Recruiter Magnet",
    text: "Transform your resume and LinkedIn into powerful tools that attract opportunities to you"
  },
  {
    icon: iconInterview,
    title: "Master Every Interview",
    text: "Walk in confident with expanded mock sessions and critiques—never guess what to say again"
  },
  {
    icon: iconSalary,
    title: "Negotiate Like a Pro",
    text: "Learn exactly how to secure higher pay and better offers with proven negotiation strategies"
  }
]
</script>

<style lang="scss" scoped>
.i-coaching-benefits {
  @include flex(column, start, center, $gap: 25px);

  margin: 50px 25px;

  @media screen and (min-width: $breakpoint-md) {
    max-width: calc(100vw - 80px);
    margin: 50px auto;
  }

  @media screen and (min-width: $breakpoint-lg) {
    max-width: 910px;
    width: 100%;
    margin: 50px auto;
  }

  .heading {
    @include flex(column, start, center, $gap: 8px);

    text-align: center;

    .title {
      @include text-lg;

      font-weight: 700;
      color: $black950;

      @media screen and (min-width: $breakpoint-sm) {
        @include text-xl;
      }
    }

    .subtitle {
      @include text-sm;

      font-weight: 400;
      color: $comet700;

      @media screen and (min-width: $breakpoint-sm) {
        @include text-md;
      }
    }
  }

  .card {
    @include border-radius-md;

    width: 100%;
    background-color: $white;
    box-shadow:
      0 10px 15px -3px #0000001a,
      0 4px 6px -4px #0000001a;
    padding: 28px;

    .benefits {
      @include grid($cols: 1fr, $rows: auto, $align-items: center, $gap: 16px);

      @media screen and (min-width: $breakpoint-md) {
        @include grid($cols: repeat(2, 1fr), $rows: repeat(2, 1fr), $align-items: stretch, $gap: 20px);
      }

      .benefit {
        @include flex(row, start, start, $gap: 14px);
        @include text-sm;

        img {
          width: 30px;
          height: 30px;
          flex-shrink: 0;
        }

        .text {
          @include flex(column, start, start, $gap: 2px);

          color: $comet700;

          .main {
            @include text-md;

            font-weight: 600;
            color: $black950;
          }

          .description {
            font-weight: 400;
            line-height: 1.4;
          }
        }
      }
    }
  }
}
</style>
